/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, August 4th 2024, 12:11:47 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

type TCell = { key: string; cell: React.ReactNode };
type TRow = TCell[];

type SimpleTableProps = {
  headData: TCell[];
  rows: TRow[];
};

export const SimpleTable = ({ headData, rows }: SimpleTableProps) => {
  return (
    <Box sx={{ overflow: "auto" }}>
      <Table>
        <TableHead>
          <TableRow>
            {headData.map((column) => (
              <TableCell key={column.key}>{column.cell}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={`${rowIndex}`}>
              {row.map((cell, cellIndex) => (
                <TableCell key={cell.key}>{cell.cell}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};
